import Header from "../../sharedScreens/Header";
import SideMenu from "../../sharedScreens/menuItems/SideMenu";
import React, { useEffect, useState } from "react";
import CMCard from "../../components/composite/CMCard";
import { UtilService } from "../../services/shared/UtilService";
import { msgTypes } from "../../constants/msgTypes";
import UserListFilter from "../../components/composite/UserListFilter";
import { Button } from "@mui/material";
import { MuiDropDown } from "../../components/basicComponent/MuiDropDown";
import MuiDatePicker from "../../components/basicComponent/MuiDatePicker";
import MuiButton from "../../components/basicComponent/MuiButton";
import { branchList, statusList } from "../../constants/constant";
import useCompanyList from "../../services/customHooks/useCompanyList";
import { formatDate } from "../../constants/helper";
import { useNavigate } from "react-router-dom";
import { useSweetAlert } from "../../services/customHooks/useSweetAlert";
import { MuiInput } from "../../components/basicComponent/MuiInput";
import ActivityIndicator from "../../components/basicComponent/ActivityIndicator";
type CorporateList = {
  id: string;
  isActive: boolean;
  phoneNumber: string;
  user: any;
  balance: string;
  businessId: string;
  businessName: string;
  type: string; //this is considered as corporate type
  mobileNo: string;
  updatedAt: string;
  userName: string; //this is considered as emailID
  updatedBy: string;
};
const CorporateList = () => {
  const { showInfo } = useSweetAlert();
  const [open, setOpen] = React.useState(false);
  const [companyList, setCompanyList] = useState<CorporateList[]>([]);
  const [companyNameList, setCompanyNameList] = useState<[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [mobile, setMobile] = useState("");
  const [corporateName, setCorporateName] = useState("");
  const [status, setStatus] = useState("");
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const filter = {
      status: true,
    };
    getCompanyList(filter);
    getCompanyNameList();
  }, []);

  const getCompanyList = async (filterPayload?: {}) => {
    setLoading(true);
    const response = await UtilService.getBusinessList(filterPayload);
    console.log("response", response);
    if (response.statusMsg === msgTypes.SUCCESS.msg) {
      setCompanyList(response?.data || []);
      setLoading(false); // end loading after fetch
    }
  };

  const getCompanyNameList = async () => {
    const response = await UtilService.getBusinessList();

    if (response.statusMsg === msgTypes.SUCCESS.msg) {
      const data = response?.data?.map((i: any) => ({
        label: i?.businessName,
        value: i?.businessName,
      }));
      setCompanyNameList(data);
    }
  };

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = companyList.slice(indexOfFirstItem, indexOfLastItem);

  const handlePageChange = (pageNumber: number) => {
    setCurrentPage(pageNumber);
  };

  const handleClick = (id: string) => {
    const corporateData = currentItems?.filter((i) => i?.id === id);
    navigate("/corporatemanagement", {
      state: {
        data: corporateData,
        isEdit: true,
      },
    });
  };
  const handleGetClick = () => {
    const isMobileValid = mobile?.trim() !== "";
    const isCorporateValid = corporateName?.trim() !== "";
    const isStatusValid = status?.trim() !== "";

    if (!isMobileValid && !isCorporateValid && !isStatusValid) {
      showInfo(
        "",
        "Please select at least one filter: Mobile, Corporate Name, or Status."
      );
      return;
    }
    const payload: any = {};
    if (mobile) payload.mobileNo = mobile;
    if (corporateName) payload.businessName = corporateName;
    if (status) payload.status = status === "active";
    getCompanyList(payload);
  };
  const handleClearClick = () => {
    if (!mobile && !corporateName && !status) {
      showInfo("", "Nothing to clear. All filters are already empty.");
      return;
    }

    setMobile("");
    setCorporateName("");
    setStatus("");

    const filter = {
      status: true,
    };
    getCompanyList(filter);
  };

  return (
    <div className=" grow">
      <SideMenu />
      <div className="wrapper flex grow flex-col">
        <Header />
        <main className="grow content" id="content" role="content">
          <div className="container-fixed">
            <div className="card-header flex-wrap">
              <h3 className="card-title">Corporate List </h3>
            </div>

            <div className="grid gap-5 lg:gap-7.5">
              <div className="card card-custom mb-5">
                <div className="card-body">
                  <div className="row  align-items-end mb-3">
                    {/* Corporate Dropdown */}
                    <div className="col-md-3 mb-2 user-manage-model">
                      <MuiInput
                        label={"Mobile Number"}
                        placeholder="Mobile Number"
                        onChange={(e) => setMobile(e)}
                        value={mobile}
                      />
                    </div>

                    {/* Mobile Input */}
                    <div className="col-md-3 mb-2 user-manage-model">
                      <MuiDropDown
                        options={companyNameList}
                        placeholder="Corporate Name"
                        onChange={(e) => setCorporateName(e)}
                        value={corporateName}
                      />
                    </div>

                    {/* User Status Dropdown */}
                    <div className="col-md-3 mb-2 user-manage-model">
                      <MuiDropDown
                        placeholder="Select Status"
                        options={statusList}
                        onChange={(val) => setStatus(val)}
                        value={status}
                      />
                    </div>

                    {/* Action Buttons */}
                    <div className="col-md-3 user-button mb-2 d-flex gap-2">
                      <MuiButton
                        className="get-btn"
                        label="Get"
                        type="button"
                        onClick={handleGetClick}
                        style={{ width: "-webkit-fill-available" }}
                      />
                      <MuiButton
                        className="clear-btn"
                        label="Clear"
                        type="button"
                        onClick={handleClearClick}
                        style={{ width: "-webkit-fill-available" }}
                      />
                    </div>
                  </div>
                  <div
                    data-datatable="true"
                    data-datatable-page-size={10}
                    id="teams_table"
                    className="table-responsive"
                  >
                    <div className="scrollable-x-auto">
                      <div
                        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
                        data-datatable-spinner="true"
                        style={{ display: "none" }}
                      >
                        <div className="flex items-center gap-2 px-4 py-2 font-medium leading-none text-2sm border border-gray-200 shadow-default rounded-md text-gray-500 bg-light">
                          <svg
                            className="animate-spin -ml-1 h-5 w-5 "
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                          >
                            <circle
                              className="opacity-25"
                              cx={12}
                              cy={12}
                              r={10}
                              stroke="currentColor"
                              strokeWidth={3}
                            />
                            <path
                              className="opacity-75"
                              fill="currentColor"
                              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                            />
                          </svg>
                          Loading...
                        </div>
                      </div>
                      <table className="table table-bordered  table-hover align-middle">
                        <thead>
                          <tr>
                            <th>
                              <span className="sort">No.</span>
                            </th>

                            <th>
                              <span className="sort">
                                <span className="sort-label ">
                                  Corporate Name
                                </span>
                                <span className="sort-icon"></span>
                              </span>
                            </th>
                            <th>
                              <span className="sort">
                                <span className="sort-label ">Phone No.</span>
                                <span className="sort-icon"></span>
                              </span>
                            </th>
                            <th>
                              <span className="sort asc">
                                <span className="sort-label ">Mobile No.</span>
                                <span className="sort-icon"></span>
                              </span>
                            </th>
                            <th>
                              <span className="sort asc">Email ID</span>
                            </th>
                            <th className="w-[200px]">
                              <span className="sort asc">Updated By</span>{" "}
                            </th>
                            <th>
                              <span className="sort asc">Balance </span>
                            </th>
                            <th className="w-[200px]">
                              <span className="sort asc">Corporate Type</span>{" "}
                            </th>
                            <th>
                              <span className="sort asc">Status </span>
                            </th>
                            <th className="w-[120px]">
                              <span className="sort asc"> Welcome Mail</span>
                            </th>
                            <th>
                              <span className="sort asc">Edit</span>{" "}
                            </th>
                          </tr>
                        </thead>
                        <tbody className="cm-card-text">
                          {loading ? (
                            <tr>
                              <td colSpan={12}>
                                <div className="d-flex justify-content-center align-items-center py-4">
                                  <ActivityIndicator />
                                </div>
                              </td>
                            </tr>
                          ) : currentItems && currentItems.length > 0 ? (
                            currentItems.map((i, index) => (
                              <CMCard
                                key={index}
                                no={index + 1}
                                balance={i.balance}
                                businessId={i.id}
                                businessName={i.businessName}
                                emailId={i.user?.email}
                                mobileNumber={i.mobileNo}
                                phoneNo={i.phoneNumber}
                                status={i.isActive}
                                updated_at={
                                  i?.updatedBy + "  " + formatDate(i.updatedAt)
                                }
                                corporateType={i.type}
                                handleEditClick={() => handleClick(i?.id)}
                                getCorporateList={() => {
                                  setMobile("");
                                  setCorporateName("");
                                  setStatus("");

                                  const filter = {
                                    status: true,
                                  };
                                  getCompanyList(filter);
                                }}
                              />
                            ))
                          ) : (
                            <tr>
                              <td colSpan={12}>
                                <div className="d-flex flex-column align-items-center justify-content-center py-4">
                                  <div
                                    className="d-flex align-items-center justify-content-center bg-light rounded-circle mb-3"
                                    style={{ width: "80px", height: "80px" }}
                                  >
                                    <img
                                      src="media/images/remove-folder.png"
                                      alt="remove-folder"
                                      style={{
                                        maxWidth: "40px",
                                        maxHeight: "40px",
                                      }}
                                    />
                                  </div>
                                  <h5 className="text-muted mb-0 fw-bold fs-5">
                                    No Corporate Data Found
                                  </h5>
                                </div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                    <div className="card-footer justify-end md:justify-end flex-col md:flex-row gap-5 text-gray-600 text-2sm font-medium">
                      {/* <div className="flex items-center gap-2 order-2 md:order-1">
                          Show
                          <select
                            className="select select-sm w-16"
                            data-datatable-size="true"
                            name="perpage"
                          >
                            <option value={5}>5</option>
                            <option value={10}>10</option>
                            <option value={20}>20</option>
                            <option value={30}>30</option>
                            <option value={50}>50</option>
                          </select>
                          per page
                        </div> */}
                      <div className="flex items-center gap-4 order-1 md:order-2">
                        <div
                          className="pagination"
                          data-datatable-pagination="true"
                        >
                          <div className="pagination">
                            <button
                              className="btn"
                              onClick={() => handlePageChange(currentPage - 1)}
                              disabled={currentPage === 1}
                            >
                              <i className="ki-outline ki-black-left rtl:transform rtl:rotate-180" />
                            </button>
                            {Array.from(
                              {
                                length: Math.ceil(
                                  companyList.length / itemsPerPage
                                ),
                              },
                              (_, i) => (
                                <button
                                  key={i + 1}
                                  className={`btn ${
                                    currentPage === i + 1 ? "active" : ""
                                  }`}
                                  onClick={() => handlePageChange(i + 1)}
                                >
                                  {i + 1}
                                </button>
                              )
                            )}
                            <button
                              className="btn"
                              onClick={() => handlePageChange(currentPage + 1)}
                              disabled={
                                currentPage ===
                                Math.ceil(companyList.length / itemsPerPage)
                              }
                            >
                              <i className="ki-outline ki-black-right rtl:transform rtl:rotate-180" />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="grid lg:grid-cols-2 gap-5 lg:gap-7.5"></div>
            </div>

            {/*-----------------pop code----------------------------  */}
            {/* <UserListFilter
              header={"Filter"}
              children={<CMFilterPopUp />}
              isVisible={open}
              handleClose={() => handleClose()}
            /> */}
          </div>
        </main>
      </div>
    </div>
  );
};

export default CorporateList;
